import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  hasAvailableKiosks: boolean;
  hostConfirmationObligatory: boolean;
  hostObligatory: boolean;
}

export const DestinationKioskStatusChip = ({
  hasAvailableKiosks,
  hostConfirmationObligatory,
  hostObligatory,
}: Props) => {
  const { t } = useTranslation(['destinations']);

  const getStatusConfig = () => {
    switch (true) {
      case !hasAvailableKiosks:
        return {
          color: 'error' as const,
          label: t('destinations:status.notAvailable'),
        };
      case hostConfirmationObligatory:
        return {
          color: 'warning' as const,
          label: t('destinations:status.hostApprovalRequired'),
        };
      case hostObligatory:
        return {
          color: 'warning' as const,
          label: t('destinations:status.hostRequired'),
        };
      default:
        return {
          color: 'success' as const,
          label: t('destinations:status.freeAccess'),
        };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <Chip variant="filled" size="small" color={statusConfig.color} label={statusConfig.label} />
  );
};
